import React from 'react'
import Link from 'gatsby-link'

const SecondPage = () => (
  <div>
    <div className='Instruction'>
      <div className='InstructionGroup'>
        <h1>Step 2: Acquire data for training</h1>
<progress value="40" max="100">40 %</progress>
        <p>* In this step, you will see a dataset containing text for training an AI-based autocomplete model. There are sentences in the dataset. Did you notice any gender bias? (Hint: look at the words after "man" and "woman")
        </p>
        <h2>
          <a href="https://drive.google.com/file/d/1iWIcNAM3PbmYxn-Am9sNIjQsO3oUzqHe/view?usp=sharing" title="Dataset" target="_blank">Dataset</a>
        </h2>
        <p></p>
        <p>* Now let's learn basics of the model we'll be using: Markov language model.
        </p>
        <Link to="/1-bias/">Back</Link>	
        <Link to="/3-rf/">Next step</Link>	
        <Link to="/">Go back to the homepage</Link>
      </div>
    </div>
  </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/2-acquire.js